import { CampanhaResponse } from 'campanha/src/types/campanha/campanhaResponse';
import { Get, Post, CustomGet } from 'domain/infra/data/api';
import campanhaConstants from "../../infra/data/campanhaConstants";
import { PagedListResponse } from 'domain/types/global/pagedListResponse';
import { CampanhaPedidoResgateResponse } from '../../types/campanha/campanhaPedidoResgateResponse';
import { PagedListRequest } from 'domain/types/global/pagedListRequest';

export class CampanhasService {
  constructor() {
  }

  GetAtivosByUsuarioPagador(usuarioId: number, empresaId: number): Promise<CampanhaResponse[] | Error> {
    return Get(`${campanhaConstants.apiCampanha.CampanhasUsuario.GetAtivosByUsuarioPagador}?usuarioId=${usuarioId}&empresaId=${empresaId}`)
  }

  async GetPedidoResgatesByLote(loteId: number, campanhaId: number, request: PagedListRequest<CampanhaPedidoResgateResponse>): Promise<PagedListResponse<CampanhaPedidoResgateResponse> | Error> {
    return await Post(
      `${campanhaConstants.apiCampanha.CampanhaLotePedido.getResgatesByLotes}?campanhaId=${campanhaId}&loteId=${loteId}`, request
    );
  }

  async GetComprovantePdf(campanhaId: number, tranferenciaId: number): Promise<Blob | Error> {
    return await CustomGet(
      `${campanhaConstants.apiCampanha.CampanhaLotePedido.getComprovantePdf}${campanhaId}/Pagamento/GetComprovante?carteirasaqueId=${tranferenciaId}`,
      {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf',
          'Content-Type': 'application/json; charset=UTF-8',
        }
      }
    );
  }
  async GetComprovantePdfByCampanhaPedidoResgate(campanhaId: number, campanhaPedidoResgate: number): Promise<Blob | Error> {
    return await CustomGet(
      `${campanhaConstants.apiCampanha.CampanhaLotePedido.getComprovantePdf}${campanhaId}/Pagamento/GetComprovanteByCampanhaPedidoResgateId?campanhaPedidoResgateId=${campanhaPedidoResgate}`,
      {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf',
          'Content-Type': 'application/json; charset=UTF-8',
        }
      }
    );
  }
}
